import { render, staticRenderFns } from "./related-tags-form.view.vue?vue&type=template&id=59e1e3e2&scoped=true"
import script from "./related-tags-form.view.vue?vue&type=script&lang=ts"
export * from "./related-tags-form.view.vue?vue&type=script&lang=ts"
import style0 from "./related-tags-form.view.vue?vue&type=style&index=0&id=59e1e3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1e3e2",
  null
  
)

export default component.exports